import React from 'react';
import { IconType } from 'react-icons';
import { useNavigate } from "react-router-dom";
import { objectToQueryParams } from "./datatable/DataTableUtils";

interface FilterQuery {
    path: string;
    query: object;
}

interface DashboardCardViewProps {
    label: string;
    icon: IconType;
    data: number;
    filterQuery: FilterQuery;
    isAllowedClick: boolean;
    isLoading: boolean;
    color?: string;
}

const DashboardCardView: React.FC<DashboardCardViewProps> = ({
    label,
    icon: Icon,
    data,
    filterQuery,
    isAllowedClick,
    isLoading,
    color = "bg-gray-500" // Default color if not provided
}) => {

    const navigate: any = useNavigate();

    return (
        <div
            className={`flex shadow-md overflow-hidden hover:scale-105 transform transition cursor-pointer ${isAllowedClick ? "hover:shadow-lg" : "opacity-70"
                } w-[95%] h-20`}
            onClick={() => {
                if (isAllowedClick) {
                    navigate({
                        pathname: filterQuery.path,
                        search: objectToQueryParams(filterQuery.query),
                        state: { detail: objectToQueryParams(filterQuery.query) }
                    });
                }
            }}
        >
            {/* Colored Icon Section */}
            <div className={`w-20 flex items-center justify-center ${color} p-3`}>
                <Icon className="text-text-0 text-2xl" />
            </div>

            {/* Text Content Section */}
            <div className="flex flex-col justify-center p-4">
                <h3 className="text-gray-700 text-sm font-medium">{label}</h3>

                <h3 className="text-black font-bold text-xl">{data}</h3>

            </div>
        </div>
    );
};

export default DashboardCardView;
